
      const apiUrl = import.meta.env.VITE_API_URL;
      if (apiUrl) {
        const apiOrigin = new URL(apiUrl).origin;
        const link = document.createElement('link');
        link.rel = 'preconnect';
        link.href = apiOrigin;
        link.crossOrigin = '';
        document.head.appendChild(link);
      }
    